import React from "react";
import ReactSkeleton, { SkeletonProps as ReactSkeletonProps } from "react-loading-skeleton";
import classNames from "classnames";

import "./Skeleton.scss";

export interface SkeletonProps extends ReactSkeletonProps {
    type?: "button" | "circle" | "pill";
}

const Skeleton = ({ type, ...props }: SkeletonProps) => {
    return (
        <span className={classNames("skeleton-wrapper", type)}>
            <ReactSkeleton {...props} />
        </span>
    );
};

export default Skeleton;
